export default ".font-trustii {\n  color: #009EB9 !important;\n}";